<template>
  <b-modal
    :dialog-class="'md_modal_dialog_full21 site-detail-width' + (page == 'Map' ? ' left' : '')"
    body-class="md_modal_body_scroll p-0"
    :modal-class="page == 'Map' ? 'md_modal_site_inquiry' : 'md_modal_full'"
    content-class="md_modal_content_full"
    :visible="visible"
    hide-footer
    hide-header
    hide-backdrop
    no-close-on-backdrop
    @show="onShowInquiry"
    @hide="onCancel"
  >
    <div class="container" style="padding:0;">
      <MdHeaderBar
        :is-custom-back="true"
        @back="onCancel"
        :hide_close="true"
        :hide_like="true"
        :hide_share="true"
        :is_like="false"
        :header_class="'site-detail-width header' + (page == 'Map' ? ' left inquiry' : '')"
        :title="{
          isSingle: false,
          primary: brItemIdx > -1 ? (brList[brItemIdx].bldNm == ' ' ? '(건물명 없음)' : brList[brItemIdx].bldNm) : '',
          address: addrInfo.address_name,
          secondary: '',
        }"
      />
      <div class="container"
            :style="page == 'Map' ? 'padding-top: 0px' : 'padding-top: 90px'">
          <div class="md_tab_header" style="margin-top: 20px;">
            <b-nav justified class="tab_bar">
              <b-nav-item @click="activeTab=TAB.TAB1"  :link-classes="[activeTab==TAB.TAB1 ? 'tab-item':'tab-item2']" :class="[activeTab==TAB.TAB1 ? 'tab_active':'tab_inactive']">건축물대장</b-nav-item>
              <b-nav-item @click="activeTab=TAB.TAB2;selectTab2();"  :link-classes="[activeTab==TAB.TAB2 ? 'tab-item':'tab-item2']" :class="[activeTab==TAB.TAB2 ? 'tab_active':'tab_inactive']" style="margin-left:10px;">공시지가</b-nav-item>
              <!-- <b-nav-item @click="activeTab=TAB.TAB3"  :link-classes="[activeTab==TAB.TAB3 ? 'tab-item':'tab-item2']" :class="[activeTab==TAB.TAB3 ? 'tab_active':'tab_inactive']">실거래가</b-nav-item> -->
            </b-nav>
          </div>

          <div v-if="activeTab==TAB.TAB1">
            <div class="site_header">
              건축물대장 간단정보
            </div>
            <div class="align-horizontal">
              <BrItem
                v-for="(item, idx) in brList"
                :item="item"
                :idx="idx"
                :selectIdx="brItemIdx"
                @click="onBrItem(idx)"
              />
            </div>

            <div class="align-vertical" v-if="brItemIdx > -1" style="margin-top: 10px;">
              <div class="align-horizontal row_info">
                <div class="row_title">건물명</div>
                <div class="row_content">{{brList[brItemIdx].bldNm == ' ' ? '-' : brList[brItemIdx].bldNm}}</div>
              </div>
              <div class="align-horizontal row_info">
                <div class="row_title">사용승인일</div>
                <div class="row_content">{{u.changeDateFormat(brList[brItemIdx].useAprDay.toString())}}</div>
              </div>
              <div class="align-horizontal">
                <div class="align-horizontal row_info" style="flex:1">
                  <div class="row_title">주용도</div>
                  <div class="row_content">{{brList[brItemIdx].mainPurpsCdNm}}</div>
                </div>
                <div class="align-horizontal row_info" style="flex:1; margin-left: 10px;">
                  <div class="row_title">주구조</div>
                  <div class="row_content">{{brList[brItemIdx].strctCdNm}}</div>
                </div>
              </div>
              <div class="align-horizontal">
                <div class="align-horizontal row_info" style="flex:1">
                  <div class="row_title">층수</div>
                  <div class="row_content">지상 {{brList[brItemIdx].grndFlrCnt}}층/지하 {{brList[brItemIdx].ugrndFlrCnt}}층</div>
                </div>
                <div class="align-horizontal row_info" style="flex:1; margin-left: 10px;">
                  <div class="row_title">호/가구/세대</div>
                  <div class="row_content">{{brList[brItemIdx].hoCnt > 0 ? brList[brItemIdx].hoCnt : '-'}}/{{brList[brItemIdx].fmlyCnt > 0 ? brList[brItemIdx].fmlyCnt : '-'}}/{{brList[brItemIdx].hhldCnt > 0 ? brList[brItemIdx].hhldCnt : '-'}}</div>
                </div>
              </div>
              <div class="align-horizontal">
                <div class="align-horizontal row_info" style="flex:1">
                  <div class="row_title">주차</div>
                  <div class="row_content">자주 {{brList[brItemIdx].indrAutoUtcnt + brList[brItemIdx].oudrAutoUtcnt}}대/기계 {{brList[brItemIdx].indrMechUtcnt + brList[brItemIdx].oudrMechUtcnt}}대</div>
                </div>
                <div class="align-horizontal row_info" style="flex:1; margin-left: 10px;">
                  <div class="row_title">승강기</div>
                  <div class="row_content">{{brList[brItemIdx].rideUseElvtCnt + brList[brItemIdx].emgenUseElvtCnt}}대</div>
                </div>
              </div>
              <!-- <div class="align-horizontal">
                <div style="flex:1">
                </div>
                <div class="align-horizontal row_info" style="flex:1; margin-left: 10px;">
                  <div class="row_title">위반여부</div>
                  <div class="row_content">없음</div>
                </div>
              </div> -->
            </div>

            <div class="site_header2">
              호별 정보
            </div>
            <div class="align-horizontal" v-if="brItemIdx > -1" style="margin-bottom: 5px;">
              <MFSelect
                class="input_wrapper input mr-1 input_wrapper_sm"
                style="flex:1; max-width: 33%;"
                :drop="true"
                :vmodel="dong_list[brItemIdx]"
                @change="(value) => {
                  onBrItem(dong_list.indexOf(value));
                }"
                :options="dong_list"
              />

              <MFSelect
                class="input_wrapper input mr-1 input_wrapper_sm"
                style="flex:1; max-width: 33%;"
                :drop="true"
                :vmodel="floor_list[flItemIdx]"
                :disabled="floor_list.length == 0"
                @change="(value) => {
                  flItemIdx = floor_list.indexOf(value);
                  hoItemIdx = 0;
                }"
                :options="floor_list"
              />

              <MFSelect
                class="input_wrapper input mr-1 input_wrapper_sm"
                style="flex:1; max-width: 33%;"
                :drop="true"
                :vmodel="ho_list[hoItemIdx]"
                :disabled="ho_list.length == 0"
                @change="(value) => {
                  hoItemIdx = ho_list.indexOf(value);
                }"
                :options="ho_list"
              />
            </div>

            <div class="align-vertical" v-if="ho_list.length > 0 && hoItemIdx > -1">
              <div v-for="item in cur_ho_list">
                <div class="align-horizontal">
                  <div class="align-horizontal row_info" style="flex:1.5">
                    <div class="row_title">주용도</div>
                    <div class="row_content">{{item.etcPurps}}</div>
                  </div>
                  <div class="align-horizontal row_info" style="flex:1; margin-left: 10px;">
                    <div class="row_title">{{item.exposPubuseGbCdNm}}면적</div>
                    <div class="row_content">{{item.area}}㎡</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="activeTab==TAB.TAB2">
            <div class="site_header">
              개별공시지가
            </div>
            <div class="site_header2">
              특수지 구분
            </div>
            <div class="align-horizontal">
              <MFSelect
                class="input_wrapper input mr-1 input_wrapper_sm"
                style="flex:1;"
                :drop="true"
                :vmodel="landType == 1 ? '일반' : '산'"
                @change="(value) => {
                  landType = value == '일반' ? 1 : 2;
                  getLandPrice(false)
                }"
                :options="['일반', '산']"
              />
              <!-- <b-button
                variant="primary"
                style="margin-right:10px;"
                class="button"
                @click="getLandPrice(false)"
                >조회</b-button
              > -->
              <b-button
                variant="none"
                class="button"
                @click="allLandPrice()"
                >전체년도</b-button
              >
            </div>
            <div class="align-vertical paragraph" style="margin-top: 10px;" v-if="landPriceList.length > 0">
              <div class="align-horizontal paragraph_row paragraph_header">
                <div class="paragraph_title">기준일자</div>
                <div class="paragraph_line"></div>
                <div class="paragraph_title">㎡당 공시지가</div>
              </div>
              <div class="align-horizontal paragraph_row paragraph_top_border" v-if="landPriceList.length > 0">
                <div class="paragraph_content">{{landPriceList[landPriceList.length - 1].stdrYear}}. 01. 01</div>
                <div class="paragraph_line"></div>
                <div class="paragraph_content">{{u.formatNumber(landPriceList[landPriceList.length - 1].pblntfPclnd)}}</div>
              </div>
            </div>
            <div class="align-horizontal" v-if="landPriceList.length == 0">
              <div class="empty_text">조회된 정보가 없습니다.</div>
            </div>

            <div class="site_header">
              공동주택가격 - 빌라, 아파트
            </div>
            <div class="site_header2" v-if="apartPriceList.length > 0">
              단지명
            </div>
            <div class="align-horizontal" v-if="apartPriceList.length > 0">
              <MFSelect
                class="input_wrapper input mr-1 input_wrapper_sm"
                style="flex:1;"
                :drop="true"
                :vmodel="aphusNm"
                @change="(value) => {
                  aphusNm = value;
                  apDongNm = '';
                  apHoNm = '';
                }"
                :options="ap_husnm_list"
              />
            </div>
            <div class="align-horizontal" v-if="apartPriceList.length > 0">
              <div class="site_header2" style="flex:1">동</div>
              <div class="site_header2" style="flex:1">호</div>
              <!-- <div style="width:70px;margin-right:10px;"></div> -->
              <div style="width:70px;"></div>
            </div>
            <div class="align-horizontal" v-if="apartPriceList.length > 0">
              <MFSelect
                class="input_wrapper input mr-1 input_wrapper_sm"
                style="flex:1;"
                :drop="true"
                :vmodel="apDongNm"
                :disabled="ap_dong_list.length == 0"
                @change="(value) => {
                  apDongNm = value;
                  apHoNm = '';
                }"
                :options="ap_dong_list"
              />
              <MFSelect
                class="input_wrapper input mr-1 input_wrapper_sm"
                style="flex:1;"
                :drop="true"
                :vmodel="apHoNm"
                :disabled="ap_ho_list.length == 0"
                @change="(value) => {
                  apHoNm = value;
                  getApartPrice2();
                }"
                :options="ap_ho_list"
              />
              <!-- <b-button
                variant="primary"
                style="margin-right:10px;"
                class="button"
                @click="getApartPrice2()"
                >조회</b-button
              > -->
              <b-button
                variant="none"
                class="button"
                @click="allApartPrice()"
                >전체년도</b-button
              >
            </div>
            <div class="align-vertical paragraph" style="margin-top: 10px;" v-if="apartPriceList.length > 0">
              <div class="align-horizontal paragraph_row paragraph_header">
                <div class="paragraph_title">공시기준</div>
                <div class="paragraph_line"></div>
                <div class="paragraph_title">전용면적(㎡)</div>
                <div class="paragraph_line"></div>
                <div class="paragraph_title">공동주택가격</div>
              </div>
              <div class="align-horizontal paragraph_row paragraph_top_border" v-if="apartPriceList2.length > 0">
                <div class="paragraph_content">{{apartPriceList2[apartPriceList2.length - 1].stdrYear}}. 01. 01</div>
                <div class="paragraph_line"></div>
                <div class="paragraph_content">{{u.formatNumber(apartPriceList2[apartPriceList2.length - 1].prvuseAr)}}</div>
                <div class="paragraph_line"></div>
                <div class="paragraph_content">{{u.formatNumber(apartPriceList2[apartPriceList2.length - 1].pblntfPc)}}</div>
              </div>
            </div>
            <div class="align-horizontal" v-if="apartPriceList.length == 0">
              <div class="empty_text">조회된 정보가 없습니다.</div>
            </div>

            <div class="site_header">
              공동주택가격 - 오피스텔
            </div>
            <div class="site_header2" v-if="offtList.length > 0">
              오피스텔명
            </div>
            <div class="align-horizontal" v-if="offtList.length > 0">
              <MFSelect
                class="input_wrapper input mr-1 input_wrapper_sm"
                style="flex:1;"
                :drop="true"
                :vmodel="offBAddr"
                :disabled="office_list.length == 0"
                @change="(value) => {
                  offBAddr = value;
                  offDong = '';
                  offFloor = '';
                  offHo = '';
                  getOfficetel2();
                }"
                :options="office_list"
              />
            </div>
            <div class="align-horizontal" v-if="offtList.length > 0">
              <div class="site_header2" style="flex:1">동</div>
              <div class="site_header2" style="flex:1">층</div>
              <div class="site_header2" style="flex:1">호</div>
            </div>
            <div class="align-horizontal" v-if="offtList.length > 0">
              <MFSelect
                class="input_wrapper input mr-1 input_wrapper_sm"
                style="flex:1;"
                :drop="true"
                :vmodel="offDong"
                :disabled="office_dong_list.length == 0"
                @change="(value) => {
                  offDong = value;
                  offFloor = '';
                  offHo = '';
                  getOfficetel3();
                }"
                :options="office_dong_list"
              />
              <MFSelect
                class="input_wrapper input mr-1 input_wrapper_sm"
                style="flex:1;"
                :drop="true"
                :vmodel="offFloor"
                :disabled="office_floor_list.length == 0"
                @change="(value) => {
                  offFloor = value;
                  offHo = '';
                  getOfficetel4();
                }"
                :options="office_floor_list"
              />
              <MFSelect
                class="input_wrapper input mr-1 input_wrapper_sm"
                style="flex:1;"
                :drop="true"
                :vmodel="offHo"
                :disabled="office_ho_list.length == 0"
                @change="(value) => {
                  offHo = value;
                  getOfficetelPrice();
                }"
                :options="office_ho_list"
              />
            </div>
            <div class="align-horizontal" style="justify-content: end; margin-top:10px;" v-if="offtList.length > 0">
              <!-- <b-button
                variant="primary"
                style="margin-right:10px;"
                class="button"
                @click="getOfficetelPrice()"
                >조회</b-button
              > -->
              <b-button
                variant="none"
                class="button"
                @click="allOfficePrice()"
                >전체년도</b-button
              >
            </div>
            <div class="align-vertical paragraph" style="margin-top: 10px;" v-if="offtPriceList.length > 0">
              <div class="align-horizontal paragraph_row paragraph_header">
                <div class="paragraph_title">고시일자</div>
                <div class="paragraph_line"></div>
                <div class="paragraph_title">건물면적(㎡)</div>
                <div class="paragraph_line"></div>
                <div class="paragraph_title">㎡당 기준시가</div>
              </div>
              <div class="align-horizontal paragraph_row paragraph_top_border" v-if="offtPriceList.length > 0">
                <div class="paragraph_content">{{u.changeDateFormat(offtPriceList[offtPriceList.length - 1].f_pbdate)}}</div>
                <div class="paragraph_line"></div>
                <div class="paragraph_content">{{u.formatNumber(parseFloat(offtPriceList[offtPriceList.length - 1].f_totarea) + parseFloat(offtPriceList[offtPriceList.length - 1].f_sharea))}}</div>
                <div class="paragraph_line"></div>
                <div class="paragraph_content">{{u.formatNumber(offtPriceList[offtPriceList.length - 1].f_pbprice)}}</div>
              </div>
              <div class="align-horizontal paragraph_row paragraph_header paragraph_top_border">
                <div class="paragraph_title">기준시가</div>
              </div>
              <div class="align-horizontal paragraph_row paragraph_top_border" v-if="offtPriceList.length > 0">
                <div class="paragraph_content">{{ u.formatNumber(Math.round(offtPriceList[offtPriceList.length - 1].f_pbprice * (parseFloat(offtPriceList[offtPriceList.length - 1].f_totarea) + parseFloat(offtPriceList[offtPriceList.length - 1].f_sharea)) ) ) }}</div>
              </div>
            </div>
            <div class="align-horizontal" v-if="offtPriceList.length == 0">
              <div class="empty_text">조회된 정보가 없습니다.</div>
            </div>

            <div class="site_header">
              개별주택공시가격
            </div>
            <div class="site_header2" v-if="invdList.length > 0">
              특수지 구분
            </div>
            <div class="align-horizontal" v-if="invdList.length > 0">
              <MFSelect
                class="input_wrapper input mr-1 input_wrapper_sm"
                style="flex:1;"
                :drop="true"
                :vmodel="invdType == 1 ? '일반' : '산'"
                @change="(value) => {
                  invdType = value == '일반' ? 1 : 2;
                  getIndvdPrice(false)
                }"
                :options="['일반', '산']"
              />
              <!-- <b-button
                variant="primary"
                style="margin-right:10px;"
                class="button"
                @click="getIndvdPrice()"
                >조회</b-button
              > -->
              <b-button
                variant="none"
                class="button"
                @click="allIndvdPrice()"
                >전체년도</b-button
              >
            </div>
            <div class="align-vertical paragraph" style="margin-top: 10px; margin-bottom: 30px;" v-if="invdList.length > 0">
              <div class="align-horizontal paragraph_row paragraph_header">
                <div class="paragraph_title">기준일자</div>
                <div class="paragraph_line"></div>
                <div class="paragraph_title">대지면적(㎡)</div>
                <div class="paragraph_line"></div>
                <div class="paragraph_title">건물연면적(㎡)</div>
              </div>
              <div class="align-horizontal paragraph_row paragraph_top_border" v-if="invdList.length > 0">
                <div class="paragraph_content">{{invdList[invdList.length - 1].stdrYear}}. 01. 01</div>
                <div class="paragraph_line"></div>
                <div class="paragraph_content">{{u.formatNumber(invdList[invdList.length - 1].buldAllTotAr)}}</div>
                <div class="paragraph_line"></div>
                <div class="paragraph_content">{{u.formatNumber(invdList[invdList.length - 1].ladRegstrAr)}}</div>
              </div>
              <div class="align-horizontal paragraph_row paragraph_header paragraph_top_border">
                <div class="paragraph_title">개별주택가격</div>
              </div>
              <div class="align-horizontal paragraph_row paragraph_top_border" v-if="invdList.length > 0">
                <div class="paragraph_content">{{u.formatNumber(invdList[invdList.length - 1].housePc)}}</div>
              </div>
            </div>
            <div class="align-horizontal" v-if="invdList.length == 0">
              <div class="empty_text">조회된 정보가 없습니다.</div>
            </div>
          </div>

          <div v-if="activeTab==TAB.TAB3">
            <div class="site_header">
              실거래가
            </div>
            <div class="align-horizontal">
              <b-button size="lg" variant="none" :class='[(actTransType == 1) ?"primary_btn": "inactive_btn"]'>매 매</b-button>
              <b-button size="lg" variant="none" :class='[(actTransType == 2) ?"primary_btn": "inactive_btn"]'>전 세</b-button>
              <b-button size="lg" variant="none" :class='[(actTransType == 3) ?"primary_btn": "inactive_btn"]'>월 세</b-button>
            </div>
            <div class="site_header2">
              최근 실거래가
            </div>
            <div class="align-horizontal">
              <div class="text1">23,600만</div>
              <div class="text2" style="flex: 1; margin-left:2px;">(24.01.02)</div>
              <div class="align-horizontal dedicate_area">
                <div class="text3" style="flex: 1; margin-left:4px;" @click="recentActTransPrice()">전용 47.62㎡ (14.41평)</div>
                <img src="../../../../assets/image/ic_dropdown@2x.png" class="drop"/>
              </div>
            </div>
            <div class="align-horizontal site_header2">
              거래내역 <div style="font-weight: bold; margin-left:5px;">5</div>건
            </div>
            <div class="align-vertical paragraph" style="margin-top: 10px; margin-bottom: 30px;">
              <div class="align-horizontal paragraph_row paragraph_header" style="height: 50px;">
                <div class="paragraph_title">거래일자</div>
                <div class="paragraph_line"></div>
                <div class="paragraph_title">거래금액</div>
                <div class="paragraph_line"></div>
                <div class="paragraph_title">전용면적당<br>단가</div>
                <div class="paragraph_line"></div>
                <div class="paragraph_title">동/층/호</div>
              </div>
              <div class="align-horizontal paragraph_row paragraph_top_border">
                <div class="paragraph_content">24. 01. 01</div>
                <div class="paragraph_line"></div>
                <div class="paragraph_content">23,600만</div>
                <div class="paragraph_line"></div>
                <div class="paragraph_content">56.3864</div>
                <div class="paragraph_line"></div>
                <div class="paragraph_content">2층 2**호</div>
              </div>
            </div>
            <div class="align-horizontal site_header2">
              실거래가 그래프
            </div>
            <div class="align-horizontal">
              <b-button size="lg" variant="none" :class='[(actGraphType == 1) ?"primary_btn2": "inactive_btn2"]'>전체</b-button>
              <b-button size="lg" variant="none" :class='[(actGraphType == 2) ?"primary_btn2": "inactive_btn2"]'>5년</b-button>
              <b-button size="lg" variant="none" :class='[(actGraphType == 3) ?"primary_btn2": "inactive_btn2"]'>3년</b-button>
              <b-button size="lg" variant="none" :class='[(actGraphType == 4) ?"primary_btn2": "inactive_btn2"]'>1년</b-button>
            </div>
            <div class="align-horizontal paragraph_graph">
              <div class="graph_title" style="font-size: 16px;">24.01</div>
              <div class="align-vertical" style="flex: 1; margin-left: 10px;">
                <div class="align-horizontal">
                  <div class="graph_btn1">매매</div>
                  <div class="graph_title" style="font-size: 12px; margin-left: 5px;">23,600만</div>
                  <div class="text2" style="font-size: 12px; margin-left: 2px;">(24.01)</div>
                </div>
                <div class="align-horizontal" style="margin-top:5px; margin-bottom: 5px;">
                  <div class="graph_btn2">전세</div>
                  <div class="graph_title" style="font-size: 12px; margin-left: 5px;">23,600만</div>
                  <div class="text2" style="font-size: 12px; margin-left: 2px;">(24.01)</div>
                </div>
                <div class="align-horizontal">
                  <div class="graph_btn3">월세</div>
                  <div class="graph_title" style="font-size: 12px; margin-left: 5px;">23,600만</div>
                  <div class="text2" style="font-size: 12px; margin-left: 2px;">(24.01)</div>
                </div>
              </div>
              <div class="graph_btn4">전세가율</div>
              <div class="graph_title" style="font-size: 12px;">100.00%</div>
            </div>
            <LineChart2 :chart-data="invdList" label="개별공시지가 - 토지"></LineChart2>
          </div>
      </div>

      <GraphPopup :page="page" :visible.sync="showGraphPopup" :list="landPriceList" :bldnm="brItemIdx > -1 ? (brList[brItemIdx].bldNm == ' ' ? '(건물명 없음)' : brList[brItemIdx].bldNm) : ''" :address="addrInfo.address_name"/>
      <GraphPopup2 :page="page" :visible.sync="showGraphPopup2" :list="apartPriceList2" :bldnm="brItemIdx > -1 ? (brList[brItemIdx].bldNm == ' ' ? '(건물명 없음)' : brList[brItemIdx].bldNm) : ''" :address="addrInfo.address_name" :dongnm="apDongNm" :honm="apHoNm"/>
      <GraphPopup3 :page="page" :visible.sync="showGraphPopup3" :list="offtPriceList" :bldnm="brItemIdx > -1 ? (brList[brItemIdx].bldNm == ' ' ? '(건물명 없음)' : brList[brItemIdx].bldNm) : ''" :address="addrInfo.address_name" :dongnm="offDong" :floornm="offFloor" :honm="offHo"/>
      <GraphPopup4 :page="page" :visible.sync="showGraphPopup4" :list="invdList" :bldnm="brItemIdx > -1 ? (brList[brItemIdx].bldNm == ' ' ? '(건물명 없음)' : brList[brItemIdx].bldNm) : ''" :address="addrInfo.address_name"/>
      <GraphPopup5 :page="page" :visible.sync="showGraphPopup5" :list="invdList"/>
    </div>
  </b-modal>
</template>

<script>
import MdHeaderBar from "../../../controls/MdHeaderBar";
import Utils from "../../../../config/utils";
import C from "../../../../config/constant"
import BrItem from "../../../controls/BrItem";
import MFSelect from "../../../controls/mf/MFSelect";
import GraphPopup from "../../../controls/popup/GraphPopup.vue";
import GraphPopup2 from "../../../controls/popup/GraphPopup2.vue";
import GraphPopup3 from "../../../controls/popup/GraphPopup3.vue";
import GraphPopup4 from "../../../controls/popup/GraphPopup4.vue";
import GraphPopup5 from "../../../controls/popup/GraphPopup5.vue";
import LineChart2 from "../../../controls/popup/LineChart2.vue";

const util = require("util");

export const TAB = {
  TAB1: '1',
  TAB2: '2',
  TAB3: '3',
};

export default {
  name: "SiteInquriy",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    keyword: {
      type: String,
      default: ''
    },
    page: {
      type: String,
      default: ''
    }
  },
  inject: ["eventBus"],
  components: {
    MdHeaderBar,
    BrItem,
    MFSelect,
    GraphPopup,
    GraphPopup2,
    GraphPopup3,
    GraphPopup4,
    GraphPopup5,
    LineChart2,
  },
  watch: {
    activeTab: function (newVal, oldVal) {

    }
  },
  computed: {
    dong_list() {
      let list = [];
      for (let i = 0; i < this.brList.length; i++) {
        if (!Utils.isEmptyOrNull(this.brList[i].dongNm.trim())) {
          list.push(this.brList[i].dongNm)
        } else {
          list.push("동명칭 없음")
        }
      }
      return list;
    },
    floor_list() {
      let list = [];
      // let flList = this.flList.filter(it => {
      //   return it.dongNm == this.brList[this.brItemIdx].dongNm;
      // });
      // for (let i = 0; i < flList.length; i++) {
      //   let floor = flList[i].flrGbCdNm + " " + flList[i].flrNo + "층";
      //   if (!list.includes(floor)) {
      //     list.push(floor)
      //   }
      // }
      let flList = this.hoList.filter(it => {
        return it.dongNm == this.brList[this.brItemIdx].dongNm;
      });
      for (let i = 0; i < flList.length; i++) {
        let floor = flList[i].flrGbCdNm + " " + (flList[i].flrNo | 0) + "층";
        if (!list.includes(floor)) {
          list.push(floor)
        }
      }

      return list;
    },
    ho_list() {
      let list = [];

      // let flList = this.flList.filter(it => {
      //   return it.dongNm == this.brList[this.brItemIdx].dongNm;
      // });
      let flList = this.hoList.filter(it => {
        return it.dongNm == this.brList[this.brItemIdx].dongNm;
      });
      let flList2 = [];
      let list2 = [];
      for (let i = 0; i < flList.length; i++) {
        // let floor = flList[i].flrGbCdNm + " " + flList[i].flrNo + "층";
        let floor = flList[i].flrGbCdNm + " " + (flList[i].flrNo | 0) + "층";
        if (!list2.includes(floor)) {
          list2.push(floor)
          flList2.push(flList[i]);
        }
      }

      let hoList = this.hoList.filter(it => {
        return it.dongNm == this.brList[this.brItemIdx].dongNm && it.flrNo == (flList2[this.flItemIdx].flrNo | 0) && it.flrGbCdNm == flList2[this.flItemIdx].flrGbCdNm;
      });
      for (let i = 0; i < hoList.length; i++) {
        if (!list.includes(hoList[i].hoNm)) {
          list.push(hoList[i].hoNm)
        }
      }
      // 호 리스트 정렬기능 추가 - 20250602
      return list.sort((a, b) => Number(a) - Number(b));
    },
    cur_ho_list() {
      let hoList = this.hoList.filter(it => {
        if (this.dong_list[this.brItemIdx] == "동명칭 없음") {
          return it.hoNm == this.ho_list[this.hoItemIdx];
        } else {
          return it.hoNm == this.ho_list[this.hoItemIdx] && it.dongNm == this.dong_list[this.brItemIdx];
        }
      });
      // 전유 항목 상단에 보이도록 재정렬 - 20250602
      hoList.sort((a, b) => {
        const keyword = '전유';
        const aIncludes = a.exposPubuseGbCdNm.includes(keyword);
        const bIncludes = b.exposPubuseGbCdNm.includes(keyword);
        if (aIncludes === bIncludes) return 0;
        return aIncludes ? -1 : 1;
      });
      return hoList;
    },
    ap_husnm_list() {
      let list = [];
      for (let i = 0; i < this.apartPriceList.length; i++) {
        if (!list.includes(this.apartPriceList[i].aphusNm)) {
          list.push(this.apartPriceList[i].aphusNm)
        }
      }
      return list;
    },
    ap_dong_list() {
      let list = [];
      let filterList = this.apartPriceList.filter(it => {
        return it.aphusNm == this.aphusNm;
      });
      for (let i = 0; i < filterList.length; i++) {
        let dongNm = filterList[i].dongNm == '' ? '동명칭 없음' : filterList[i].dongNm;
        if (!list.includes(dongNm)) {
          list.push(dongNm)
        }
      }
      return list;
    },
    ap_ho_list() {
      let list = [];
      let filterList = this.apartPriceList.filter(it => {
        return it.aphusNm == this.aphusNm && it.dongNm == (this.apDongNm == '동명칭 없음' ? '' : this.apDongNm);
      });
      for (let i = 0; i < filterList.length; i++) {
        if (!list.includes(filterList[i].hoNm)) {
          list.push(filterList[i].hoNm)
        }
      }
      list.sort((a, b) => {
        return parseInt(a) > parseInt(b) ? 1 : -1;
      });
      return list;
    },
    office_list() {
      let list = [];
      for (let i = 0; i < this.offtList.length; i++) {
        if (!list.includes(this.offtList[i].f_build_addr)) {
          list.push(this.offtList[i].f_build_addr)
        }
      }
      return list;
    },
    office_dong_list() {
      let list = [];
      for (let i = 0; i < this.offtList2.length; i++) {
        if (!list.includes(this.offtList2[i].f_dong)) {
          list.push(this.offtList2[i].f_dong)
        }
      }
      return list;
    },
    office_floor_list() {
      let list = [];
      for (let i = 0; i < this.offtList3.length; i++) {
        if (!list.includes(this.offtList3[i].f_floor)) {
          list.push(this.offtList3[i].f_floor)
        }
      }
      list.sort((a, b) => {
        return parseInt(a) > parseInt(b) ? 1 : -1;
      });
      return list;
    },
    office_ho_list() {
      let list = [];
      for (let i = 0; i < this.offtList4.length; i++) {
        if (!list.includes(this.offtList4[i].f_ho)) {
          list.push(this.offtList4[i].f_ho)
        }
      }
      return list;
    },
  },

  data() {
    return {
      self: this,
      u: Utils,
      ut: util,
      TAB: TAB,
      activeTab: TAB.TAB1,
      loaded2: false,
      addrInfo: {},
      brList: [],
      brItemIdx: -1,
      flList: [],
      flItemIdx: -1,
      hoList: [],
      hoItemIdx: -1,
      landPriceList: [],
      landType: 1,
      apartPriceList: [],
      apartPriceList2: [],
      aphusNm:"",
      apDongNm: "",
      apHoNm: "",
      invdList: [],
      invdType: 1,
      offtList: [],
      offBAddr: "",
      offtList2: [],
      offDong: "",
      offtList3: [],
      offFloor: "",
      offtList4: [],
      offHo: "",
      offtPriceList: [],
      actTransType: 1, //1:매매,2:전세,3:월세
      actGraphType: 1, //1:전체,2:5년,3:3년,4:1년,
      showGraphPopup: false,
      showGraphPopup2: false,
      showGraphPopup3: false,
      showGraphPopup4: false,
      showGraphPopup5: false,
    };
  },
  methods: {
    selectTab2() {
      if (!this.loaded2) {
        this.getLandPrice(true);
        this.loaded2 = true;
      }
    },
    onBrItem(idx) {
      this.brItemIdx = idx;
      this.flItemIdx = 0;
      this.hoItemIdx = 0;
    },

    onCancel() {
      console.log("-------------onCancel----------------");
      if (window.history.state == "forward2") window.history.back();
    },

    onShowInquiry() {
      console.log("-------------onshowdetail----------------");
      this.eventBus.$emit("setModal", this);
      window.history.pushState("forward2", null);
      Utils.setState(this, {
        activeTab: TAB.TAB1,
        loaded2: false,
        addrInfo: {},
        brItemIdx: -1,
        brList: [],
        flItemIdx: -1,
        flList: [],
        hoItemIdx: -1,
        hoList: [],
        landPriceList: [],
        landType: 1,
        apartPriceList: [],
        apartPriceList2: [],
        aphusNm:"",
        apDongNm: "",
        apHoNm: "",
        invdList: [],
        invdType: 1,
        offtList: [],
        offBAddr: "",
        offtList2: [],
        offDong: "",
        offtList3: [],
        offFloor: "",
        offtList4: [],
        offHo: "",
        offtPriceList: [],
        actTransType: 1,
        actGraphType: 1
      });

      Utils.requestGet(this.$c.API.Site.findAddress, {
        query: this.keyword,
      }).then((result) => {
        (result);
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.addrInfo = result.data;
          if (!this.addrInfo.address_name || !this.addrInfo.b_code || !this.addrInfo.main_address_no /*|| !this.addrInfo.sub_address_no*/) {
            Utils.toast(this, "정확한 지번 주소를 입력해주세요.");
            this.onCancel();
            return;
          }

          //tab1
          this.getBrTitleInfo(1);

          //tab2
          // this.getLandPrice(true);

          //tab3
          // this.getActualTransaction();
        } else {
          Utils.toast(this, "정확한 지번 주소를 입력해주세요.");
        }
      });
    },

    getActualTransaction() {
      Utils.requestGet(this.$c.API.INQUIRY.getActualTransaction, {
        key: C.DATAGO_SERVICE_KEY,
        // pnu: this.addrInfo.b_code + "1" + Utils.pad(this.addrInfo.main_address_no, 4) + Utils.pad(this.addrInfo.sub_address_no, 4),
        pnu: '11650',
        date: '202404'
      }).then((result) => {
        console.log(result);
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
        } else {
          Utils.toast(this, "정확한 지번 주소를 입력해주세요.");
        }
      });
    },

    getLandPrice(next) {
      Utils.requestGet(this.$c.API.INQUIRY.getLandPrice, {
        key: C.VWORD_SERVICE_KEY,
        domain: 'https://madepf.com/',
        pnu: this.addrInfo.b_code + this.landType + Utils.pad(this.addrInfo.main_address_no, 4) + Utils.pad(this.addrInfo.sub_address_no, 4),
        numOfRows: 1000,
        pageNo: 1,
        format: 'json'
      }).then((result) => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.landPriceList = [];
          //remove duplicated by stdrYear
          let filtered = result.data.filter(
            (item, index) => index === result.data.findIndex(
              other => item.stdrYear === other.stdrYear
            ));
          this.landPriceList = filtered;

          if (next) {
            this.getApartPrice(1);
          }
        } else {
          Utils.toast(this, "정확한 지번 주소를 입력해주세요.");
        }
      });
    },

    getApartPrice(page) {
      Utils.requestGet(this.$c.API.INQUIRY.getApartPrice, {
        key: C.VWORD_SERVICE_KEY,
        domain: 'https://madepf.com/',
        pnu: this.addrInfo.b_code + "1" + Utils.pad(this.addrInfo.main_address_no, 4) + Utils.pad(this.addrInfo.sub_address_no, 4),
        // dongNm: "",
        // hoNm: "",
        numOfRows: 1000,
        pageNo: page,
        format: 'json'
      }).then((result) => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          let totalCount = result.data.totalCount;
          if (page == 1) {
            this.apartPriceList = [];
          }
          if (totalCount > 0) {
            this.apartPriceList = this.apartPriceList.concat(result.data.list);
          }

          if (totalCount > page * 1000) {
            this.getApartPrice(page + 1);
          } else  {
            if (this.ap_husnm_list.length > 0) {
              this.aphusNm = this.ap_husnm_list[0];
              if (this.ap_dong_list.length > 0) {
                this.apDongNm = this.ap_dong_list[0];

                if (this.ap_ho_list.length > 0) {
                  this.apHoNm = this.ap_ho_list[0];

                  this.getApartPrice2();
                }
              }
            }

            this.getIndvdPrice(true);
          }
        } else {
          Utils.toast(this, "정확한 지번 주소를 입력해주세요.");
        }
      });
    },

    getIndvdPrice(next) {
      Utils.requestGet(this.$c.API.INQUIRY.getIndvdPrice, {
        key: C.VWORD_SERVICE_KEY,
        domain: 'https://madepf.com/',
        pnu: this.addrInfo.b_code + this.invdType + Utils.pad(this.addrInfo.main_address_no, 4) + Utils.pad(this.addrInfo.sub_address_no, 4),
        // pnu: "1165010600" + this.invdType,
        numOfRows: 1000,
        pageNo: 1,
        format: 'json'
      }).then((result) => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.invdList = [];

          //remove duplicated by stdrYear
          let filtered = result.data.filter(
            (item, index) => index === result.data.findIndex(
              other => item.stdrYear === other.stdrYear
            ));
          this.invdList = filtered;

          if (next) {
            this.getOfficetel();
          }
        } else {
          Utils.toast(this, "정확한 지번 주소를 입력해주세요.");
        }
      });
    },

    getOfficetel() {
      Utils.requestGet(this.$c.API.INQUIRY.getOfficetel, {
        pnu: this.addrInfo.b_code,
        bun: Utils.pad(this.addrInfo.main_address_no, 4),
        ji: Utils.pad(this.addrInfo.sub_address_no, 4),
      }).then((result) => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.offtList = [];
          this.offtList = result.data;

          if (this.office_list.length > 0) {
            this.offBAddr = this.office_list[0];
            this.getOfficetel2();
          }
        } else {
          Utils.toast(this, "정확한 지번 주소를 입력해주세요.");
        }
      });
    },

    getOfficetel2() {
      let list = this.offtList.filter(it => {
        return it.f_build_addr == this.offBAddr;
      });

      Utils.requestGet(this.$c.API.INQUIRY.getOfficetel2, {
        pnu: this.addrInfo.b_code,
        bun: Utils.pad(this.addrInfo.main_address_no, 4),
        ji: Utils.pad(this.addrInfo.sub_address_no, 4),
        buildnum: list[0].f_buildnum,
      }).then((result) => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.offtList2 = [];
          this.offtList2 = result.data;

          if (this.office_dong_list.length > 0) {
            this.offDong = this.office_dong_list[0];
            this.getOfficetel3();
          }
        } else {
          Utils.toast(this, "정확한 지번 주소를 입력해주세요.");
        }
      });
    },

    getOfficetel3() {
      let list = this.offtList.filter(it => {
        return it.f_build_addr == this.offBAddr;
      });

      Utils.requestGet(this.$c.API.INQUIRY.getOfficetel3, {
        pnu: this.addrInfo.b_code,
        bun: Utils.pad(this.addrInfo.main_address_no, 4),
        ji: Utils.pad(this.addrInfo.sub_address_no, 4),
        buildnum: list[0].f_buildnum,
        dong: this.offDong,
      }).then((result) => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.offtList3 = [];
          this.offtList3 = result.data;

          if (this.office_floor_list.length > 0) {
            this.offFloor = this.office_floor_list[0];
            this.getOfficetel4();
          }
        } else {
          Utils.toast(this, "정확한 지번 주소를 입력해주세요.");
        }
      });
    },

    getOfficetel4() {
      let list = this.offtList.filter(it => {
        return it.f_build_addr == this.offBAddr;
      });

      Utils.requestGet(this.$c.API.INQUIRY.getOfficetel4, {
        pnu: this.addrInfo.b_code,
        bun: Utils.pad(this.addrInfo.main_address_no, 4),
        ji: Utils.pad(this.addrInfo.sub_address_no, 4),
        buildnum: list[0].f_buildnum,
        dong: this.offDong,
        floor: this.offFloor,
      }).then((result) => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.offtList4 = [];
          this.offtList4 = result.data;

          if (this.office_ho_list.length > 0) {
            this.offHo = this.office_ho_list[0];
            this.getOfficetelPrice();
          }
        } else {
          Utils.toast(this, "정확한 지번 주소를 입력해주세요.");
        }
      });
    },

    getOfficetelPrice() {
      let list = this.offtList.filter(it => {
        return it.f_build_addr == this.offBAddr;
      });

      Utils.requestGet(this.$c.API.INQUIRY.getOfficetelPrice, {
        pnu: this.addrInfo.b_code,
        bun: Utils.pad(this.addrInfo.main_address_no, 4),
        ji: Utils.pad(this.addrInfo.sub_address_no, 4),
        buildnum: list[0].f_buildnum,
        dong: this.offDong,
        floor: this.offFloor,
        ho: this.offHo,
      }).then((result) => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.offtPriceList = [];
          this.offtPriceList = result.data;
        } else {
          Utils.toast(this, "정확한 지번 주소를 입력해주세요.");
        }
      });
    },

    getApartPrice2() {
      if (this.aphusNm == '' || this.apDongNm == '' || this.apHoNm == '') return;
      Utils.requestGet(this.$c.API.INQUIRY.getApartPrice2, {
        key: C.VWORD_SERVICE_KEY,
        domain: 'https://madepf.com/',
        pnu: this.addrInfo.b_code + "1" + Utils.pad(this.addrInfo.main_address_no, 4) + Utils.pad(this.addrInfo.sub_address_no, 4),
        dongNm: this.apDongNm,
        hoNm: this.apHoNm,
        numOfRows: 1000,
        pageNo: 1,
        format: 'json'
      }).then((result) => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.apartPriceList2 = [];

          //remove duplicated by stdrYear
          let filtered = result.data.list.filter(
            (item, index) => index === result.data.list.findIndex(
              other => item.stdrYear === other.stdrYear
            ));
          this.apartPriceList2 = filtered;
        } else {
          Utils.toast(this, "정확한 지번 주소를 입력해주세요.");
        }
      });
    },

    allLandPrice() {
      this.showGraphPopup = true;
    },
    allApartPrice() {
      this.showGraphPopup2 = true;
    },
    allOfficePrice() {
      this.showGraphPopup3 = true;
    },
    allIndvdPrice() {
      this.showGraphPopup4 = true;
    },
    recentActTransPrice() {
      this.showGraphPopup5 = true;
    },

    getBrTitleInfo(page) {
      Utils.requestGet2(this.$c.API.INQUIRY.getBrTitleInfo, {
        serviceKey: C.DATAGO_SERVICE_KEY,
        sigunguCd: this.addrInfo.b_code.substr(0, 5),
        bjdongCd: this.addrInfo.b_code.substr(5, 5),
        platGbCd: 0,
        bun: Utils.pad(this.addrInfo.main_address_no, 4),
        ji: Utils.pad(this.addrInfo.sub_address_no, 4),
        numOfRows: 100,
        pageNo: page,
        _type: 'json'
      }).then((result) => {
        if (result.response.header.resultCode == '00') {
          let totalCount = result.response.body.totalCount;
          if (totalCount == 0) { //건물 없음
            Utils.toast(this, "해당 주소는 건축물대장 말소(생성 전) 상태입니다.");
            return;
          }
          let pageNo = result.response.body.pageNo;
          if (page == 1) {
            this.brList = [];
          }
          if (totalCount > 0) {
            this.brList = this.brList.concat(result.response.body.items.item);
          }

          if (totalCount > pageNo * 100) {
            this.getBrTitleInfo(page + 1);
          } else {
            //sort by dongnm
            this.brList.sort((a, b) => {
              return a.dongNm < b.dongNm ? 1 : -1;
            });
            this.onBrItem(0);

            this.getBrFlrOulnInfo(1);
          }
        } else {
          Utils.toast(this, "정확한 지번 주소를 입력해주세요.");
        }
      });
    },

    getBrFlrOulnInfo(page) {
      Utils.requestGet2(this.$c.API.INQUIRY.getBrFlrOulnInfo, {
        serviceKey: C.DATAGO_SERVICE_KEY,
        sigunguCd: this.addrInfo.b_code.substr(0, 5),
        bjdongCd: this.addrInfo.b_code.substr(5, 5),
        platGbCd: 0,
        bun: Utils.pad(this.addrInfo.main_address_no, 4),
        ji: Utils.pad(this.addrInfo.sub_address_no, 4),
        numOfRows: 100,
        pageNo: page,
        _type: 'json'
      }).then((result) => {
        if (result.response.header.resultCode == '00') {
          let totalCount = result.response.body.totalCount;
          let pageNo = result.response.body.pageNo;
          if (page == 1) {
            this.flList = [];
          }
          if (totalCount > 0) {
            this.flList = this.flList.concat(result.response.body.items.item);
          }

          if (totalCount > pageNo * 100) {
            this.getBrFlrOulnInfo(page + 1);
          } else {
            //sort by dong,floor
            this.flList.sort((a, b) => {
              if (a.dongNm === b.dongNm) {
                if (a.flrGbCd === b.flrGbCd) {
                  return a.flrNo > b.flrNo ? 1 : -1;
                }
                return a.flrGbCd > b.flrGbCd ? 1 : -1;
              }
              return a.dongNm > b.dongNm ? 1 : -1;
            });

            this.getBrExposInfo(1);
          }
        } else {
          Utils.toast(this, "정확한 지번 주소를 입력해주세요.");
        }
      });
    },

    getBrExposInfo(page) {
      Utils.requestGet2(this.$c.API.INQUIRY.getBrExposInfo, {
        serviceKey: C.DATAGO_SERVICE_KEY,
        sigunguCd: this.addrInfo.b_code.substr(0, 5),
        bjdongCd: this.addrInfo.b_code.substr(5, 5),
        platGbCd: 0,
        bun: Utils.pad(this.addrInfo.main_address_no, 4),
        ji: Utils.pad(this.addrInfo.sub_address_no, 4),
        numOfRows: 100,
        pageNo: page,
        _type: 'json'
      }).then((result) => {
        if (result.response.header.resultCode == '00') {
          let totalCount = result.response.body.totalCount;
          let pageNo = result.response.body.pageNo;
          if (page == 1) {
            this.hoList = [];
          }
          if (totalCount > 0) {
            this.hoList = this.hoList.concat(result.response.body.items.item);
          }

          if (totalCount > pageNo * 100) {
            this.getBrExposInfo(page + 1);
          } else {
            //sort by dong
            this.hoList.sort((a, b) => {
              if (a.dongNm === b.dongNm) {
                if (a.flrGbCdNm === b.flrGbCdNm) {
                  if (a.flrNo === b.flrNo) {
                  if (a.hoNm === b.hoNm) {
                    if (a.exposPubuseGbCd === b.exposPubuseGbCd) {
                      return a.etcPurps > b.etcPurps ? 1 : -1;
                    }
                    return a.exposPubuseGbCd > b.exposPubuseGbCd ? 1 : -1;
                  }
                  return a.hoNm > b.hoNm ? 1 : -1;
                }
                  return a.flrNo > b.flrNo ? 1 : -1;
                }
                return a.flrGbCdNm > b.flrGbCdNm ? 1 : -1;
              }
              return a.dongNm > b.dongNm ? 1 : -1;
            });
          }
        } else {
          Utils.toast(this, "정확한 지번 주소를 입력해주세요.");
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/css/main/interest/SiteDetail";
@import "../../../../assets/css/vars";
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
.tab_bar {border-bottom:0;  height: 43px;width: 448px;}
.tab-item {
  color:white;
  font-size: $fs_18;
  font-family: $korean_gd_15_r;
}
.tab-item2 {
  color:black;
  font-size: $fs_18;
  font-family: $korean_gd_15_r;
}
.tab_active {background-color: $primary; border-radius: 5px;}
.tab_inactive {background-color: #deebf7; border-radius: 5px;}

.site_header{
  margin-bottom: 7px;
  margin-top: 20px;
  color: $black;
  font-size: $fs_18;
  font-family: $korean_gd_15_r;
}

.site_header2{
  margin-bottom: 7px;
  margin-top: 10px;
  color: $black;
  font-size: $fs_16;
  font-family: $korean_gd_15_r;
}

.row_info {
  height: 45px;
  border-bottom: 1px solid $c_cacbcd;
}

.row_title {
  // flex: 1;
  margin-right: 10px;
  font-size: $fs_15;
  font-family: $korean_gd_14_r;
  color: $c_6c6969;
}

.row_content {
  flex: 1;
  text-align: end;
  font-size: $fs_15;
  font-family: $korean_gd_15_r;
  //font-weight: bold;
  color: $black;
}
.input {
  color: $black;
  font-size: $fs_15;
  font-family: $korean_gd_12_r;
  padding: 0 12px;
}
.button {
  width: 70px;
  height: 40px;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  color: $white;
  background-color: $charter1;
  font-size: $fs_14;
  font-family: $korean_gd_14_r;
  text-align: center;
  padding: 0 0.1em;
}

.paragraph {
  border: 1px solid $c_cacbcd;
}
.paragraph_row {
  height: 35px;
}
.paragraph_header {
  background-color: #e8f1f4;
}
.paragraph_top_border {
  border-top: 1px solid $c_cacbcd;
}
.paragraph_line {
  width:1px;
  height:100%;
  background-color:$c_cacbcd;
}
.paragraph_title {
  flex:1;
  font-size: $fs_15;
  font-family: $korean_gd_13_r;
  font-weight: bold;
  color: $black;
  text-align: center;
}
.paragraph_content {
  flex:1;
  font-size: $fs_15;
  font-family: $korean_gd_14_r;
  color: $black;
  text-align: center;
}
.empty_text {
  flex:1;
  font-size: $fs_16;
  font-family: $korean_gd_14_r;
  color: $c_727373;
  margin-top: 5px;
}
.primary_btn {
  background-color: $primary;
  width: 55px;
  border-radius: 3px;
  padding: 0;
  font-size: 14px;
  font-family: $korean_gd_15_r;
  color: white;
  margin-right: 5px;
}
.inactive_btn {
  @extend .primary_btn;
  background-color: white;
  border: solid 1px $c_cacbcd;
  color: $c_cacbcd;
}
.primary_btn2 {
  @extend .primary_btn;
  width: 40px;
  font-size: 11px;
  background-color: $white;
  color: $primary;
  border: solid 1px $primary;
}
.inactive_btn2 {
  @extend .primary_btn2;
  background-color: white;
  border: solid 1px $c_cacbcd;
  color: $c_cacbcd;
}
.text1 {
  font-size: $fs_14;
  font-family: $korean_gd_14_r;
  font-weight: bold;
  color: $primary;
}
.text2 {
  font-size: $fs_12;
  font-family: $korean_gd_14_r;
  color: $c_6c6969;
}
.text3 {
  font-size: $fs_11;
  font-family: $korean_gd_11_r;
  font-weight: bold;
  color: $primary;
}
.dedicate_area {
  border: solid 1px $primary;
  border-radius: 3px;
  height: 30px;
  cursor: pointer;
}
.drop {
  width: 8px;
  height: 8px;
  margin-left: 10px;
  margin-right: 5px;
  filter: invert(52%) sepia(68%) saturate(5400%) hue-rotate(203deg) brightness(100%) contrast(103%);
}
.paragraph_graph {
  border-radius: 5px;
  background-color: #deebf7;
  width: 100%;
  padding: 5px 10px;
  margin-top:10px;
}
.graph_title {
  font-size: $fs_14;
  font-family: $korean_gd_14_r;
  font-weight: bold;
  color: $black;
  text-align: center;
}
.graph_btn1 {
  background-color: rgb(207, 0, 0);
  width: 40px;
  height: 22px;
  color: white;
  border-radius: 4px;
  font-size: $fs_14;
  font-family: $korean_gd_14_r;
  margin-right: 5px;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding-top: 1px;
}
.graph_btn2 {
  @extend .graph_btn1;
  background-color: rgb(8, 64, 186);
}
.graph_btn3 {
  @extend .graph_btn1;
  background-color: rgb(8, 110, 22);
}
.graph_btn4 {
  @extend .graph_btn1;
  width: 60px;
  background-color: rgb(175, 171, 171);
}
</style>



// WEBPACK FOOTER //
// src/components/contents/main/interest/SiteInquiry.vue